
import { State, Action } from "vuex-class";
import { Component, Vue } from "vue-property-decorator";
import { setToken } from "@/functions/token.function";

@Component({
  components: {},
})
export default class VerifyEmail extends Vue {
  @State("user", { namespace: "auth" })
  private user!: any;
  @Action("sendLoginOtp", { namespace: "auth" })
  private sendLoginOtp: any;
  @Action("validateLoginOtp", { namespace: "auth" })
  private validateLoginOtp: any;
  @Action("sendRegisterOtp", { namespace: "auth" })
  private sendRegisterOtp: any;
  @Action("validateRegisterOtp", { namespace: "auth" })
  private validateRegisterOtp: any;
  @Action("getSelf", { namespace: "auth" })
  private getSelf: any;

  private otpDigits: string[] = ['', '', '', '', '', ''];
  private isVerifying = false;
  private resendTimer = 120; // Start with 2 minutes
  private canResend = false; // Start disabled
  private isLoading = true;
  private redirect: string = this.$route.query.redirect as string;

  private get isOtpComplete(): boolean {
    return this.otpDigits.every(digit => digit !== '');
  }

  private get otpCode(): string {
    return this.otpDigits.join('');
  }

  private handleOtpInput(event: Event, index: number): void {
    const target = event.target as HTMLInputElement;
    const value = target.value;

    // Only allow numbers
    if (!/^\d*$/.test(value)) {
      this.otpDigits[index] = '';
      return;
    }

    // Limit to one digit
    if (value.length > 1) {
      this.otpDigits[index] = value.slice(0, 1);
    } else {
      this.otpDigits[index] = value;
    }

    // Move to next input if current input has a value
    if (value && index < 5) {
      this.$nextTick(() => {
        const nextInput = this.$refs[`otpInput${index + 1}`] as HTMLInputElement[];
        if (nextInput && nextInput[0]) {
          nextInput[0].focus();
        }
      });
    }
  }

  private handleKeydown(event: KeyboardEvent, index: number): void {
    // Handle backspace
    if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
      this.otpDigits[index - 1] = '';
      this.$nextTick(() => {
        const prevInput = this.$refs[`otpInput${index - 1}`] as HTMLInputElement[];
        if (prevInput && prevInput[0]) {
          prevInput[0].focus();
        }
      });
    }
  }

  private handlePaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text/plain');

    if (pastedData && /^\d{6}$/.test(pastedData)) {
      this.otpDigits = pastedData.split('');
      // Focus the last input
      this.$nextTick(() => {
        const lastInput = this.$refs[`otpInput5`] as HTMLInputElement[];
        if (lastInput && lastInput[0]) {
          lastInput[0].focus();
        }
      });
    }
  }

  private handleFocus(index: number): void {
    // Select all text when focusing on an input
    const input = this.$refs[`otpInput${index}`] as HTMLInputElement[];
    if (input && input[0]) {
      input[0].select();
    }
  }

  private verifyEmail(): void {
    if (!this.isOtpComplete || this.isVerifying) return;

    this.isVerifying = true;

    if (this.redirect === 'login') {
      this.validateLoginOtp({
        params: {
          email: this.$route.query.email,
          otp: this.otpCode,
        },
        error: (error) => {
          alert("Something went wrong");
        },
        success: (response: any) => {
          // After successful OTP validation, fetch user data
          setToken(response.data.data.token);
          this.getSelf().then(() => {
            const courseSlug = this.$route.query?.course;
            const bundleSlug = this.$route.query?.bundle;
            if (bundleSlug && typeof bundleSlug === 'string') {
              this.$router.push({
                name: "bundle-course-detail",
                params: { slug: bundleSlug },
              });
            } else if (courseSlug && typeof courseSlug === 'string') {
              this.$router.push({
                name: "course-detail",
                params: { slug: courseSlug },
              });
            } else {
              this.$router.push({
                name: "home",
              });
            }
          });
        },
        finally: () => {
          this.isVerifying = false;
        },
      })
    } else {
      this.validateRegisterOtp({
        params: {
          email: this.$route.query.email,
          otp: this.otpCode,
        },
        error: (error) => {
          alert("Something went wrong");
        },
        success: (response: any) => {
          // After successful OTP validation, fetch user data
          setToken(response.data.data.token);
          this.getSelf().then(() => {
            this.$router.push({
              name: "home",
            });
          });
        },
        finally: () => {
          this.isVerifying = false;
        },
      });
    }

    // Back to login page
    // clearToken();
    // this.$router.push({
    // 	name: 'home',
    // });
  }

  private formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  private resendCode(): void {
    if (!this.canResend) return;

    if (this.redirect === 'login') {
      this.sendLoginOtp({
        params: {
          email: this.$route.query.email,
        },
        error: (error) => {
          alert("Something went wrong");
        },
      });
    } else {
      this.sendRegisterOtp({
        params: {
          email: this.$route.query.email,
        },
        error: (error) => {
          alert("Something went wrong");
        },
      });
    }

    // Restart timer after resending
    this.canResend = false;
    this.resendTimer = 120; // 2 minutes = 120 seconds
    this.startCountdown();
  }

  private resetOtp(): void {
    this.otpDigits = ['', '', '', '', '', ''];
    // Focus first input
    this.$nextTick(() => {
      const firstInput = this.$refs[`otpInput0`] as HTMLInputElement[];
      if (firstInput && firstInput[0]) {
        firstInput[0].focus();
      }
    });
  }

  private mounted(): void {
    // Start checking for user data
    // this.checkUserData();
    // this.waitingUserAndSendOtp();

    this.startCountdown();
  }

  // private checkUserData(): void {
  //   const checkInterval = setInterval(() => {
  //     if (this.user && this.user !== null && this.user !== undefined) {
  //       // User data is loaded, stop loading and start countdown
  //       this.isLoading = false;
  //       clearInterval(checkInterval);

  // 			if (this.user.email_verified_at !== null) {
  // 				this.$router.push({
  // 					name: 'home',
  // 				});
  // 			}

  //       // Focus first input after loading
  //       this.$nextTick(() => {
  //         const firstInput = this.$refs[`otpInput0`] as HTMLInputElement[];
  //         if (firstInput && firstInput[0]) {
  //           firstInput[0].focus();
  //         }
  //       });

  //       // Start the countdown timer after user data is loaded
  //       this.startCountdown();
  //     }
  //   }, 100); // Check every 100ms
  // }

  // private waitingUserAndSendOtp(): void {
  //   const checkInterval = setInterval(() => {
  //     if (this.user && this.user !== null && this.user !== undefined) {
  //       clearInterval(checkInterval);
  //       this.sendOtp({
  //         params: {
  //           email: this.$route.query.email,
  //         },
  //         error: (error) => {
  //           alert("Something went wrong");
  //         },
  //       });
  //     }
  //   }, 100)
  // }

  private startCountdown(): void {
    const timer = setInterval(() => {
      this.resendTimer--;
      if (this.resendTimer <= 0) {
        this.canResend = true;
        clearInterval(timer);
      }
    }, 1000);
  }
}
